import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Entity } from '../../../../types/utility';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { APPLICATION_BASE_PATH } from '../../../middle-office/application/constants/applicationBasePath';
import { postCreateDocument } from '../../requests/postDocument';

export const useCreateDocument = () => {
  const queryClient = useQueryClient();
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: createDocument, ...rest } = useMutation({
    mutationFn: ({
      definitionName,
      workflowName,
      data,
      includes,
    }: {
      definitionName: string;
      workflowName?: string;
      data: Entity;
      includes?: string[];
    }) =>
      postCreateDocument(
        constructPost,
        definitionName,
        workflowName,
        data,
        includes,
      ),
    onSuccess: (_, { definitionName }) => {
      queryClient.invalidateQueries({
        queryKey: [APPLICATION_BASE_PATH, definitionName],
      });
    },
  });

  return { createDocument, ...rest };
};
